import { defineCopy } from '../pageCopy';

const en = {
  meta: {
    title: 'Contact Us',
    description:
      'Get in touch with Datacode for AI Integration, LLM Solutions, Web Development, and Mobile App Development services. Located in Erbil, Kurdistan Region.',
    ogTitle: 'Contact Us | Datacode',
    ogDescription:
      'Get in touch with Datacode for AI Integration, LLM Solutions, Web Development, and Mobile App Development services.',
  },
  hero: {
    eyebrow: 'Get in Touch',
    title: 'CONTACT',
    subtitle:
      "Tell us what you want to build. You'll talk to the people who would design and write it: web apps, AI tools, and mobile products, from Erbil.",
    scroll: 'Scroll to Explore',
    connect: "Let's Connect",
  },
  info: {
    eyebrow: 'Get in Touch',
    title: "LET'S TALK",
    emailLabel: 'Email',
    phoneLabel: 'Phone',
    addressLabel: 'Address',
    addressLine1: 'B80, Floor 20, MRF 2 towers',
    addressLine2: 'English Village Rd, Erbil',
  },
  form: {
    nameLabel: 'Name',
    namePlaceholder: 'Your full name',
    emailLabel: 'Email',
    emailPlaceholder: 'your@email.com',
    messageLabel: 'Message',
    messagePlaceholder: 'Tell us about your project...',
    send: 'Send Message',
    sending: 'Sending...',
    success: 'Thank you! Your message has been sent successfully.',
    error: 'Something went wrong. Please try again.',
    validation: {
      nameMin: 'Name must be at least 2 characters',
      emailInvalid: 'Please enter a valid email',
      messageMin: 'Message must be at least 10 characters',
    },
  },
  map: {
    iframeTitle: 'Datacode Location',
    watermark: 'ERBIL',
    officeLabel: 'DataCode Office',
    getDirections: 'Get Directions',
  },
  cta: {
    eyebrow: 'Ready to see our work?',
    title: 'PROJECTS',
  },
};

const ar: typeof en = {
  meta: {
    title: 'تواصل معنا',
    description:
      'تواصل مع Datacode لخدمات دمج الذكاء الاصطناعي وحلول النماذج اللغوية وتطوير المواقع وتطبيقات الموبايل. مقرنا في أربيل، إقليم كوردستان.',
    ogTitle: 'تواصل معنا | Datacode',
    ogDescription:
      'تواصل مع Datacode لخدمات دمج الذكاء الاصطناعي وحلول النماذج اللغوية وتطوير المواقع وتطبيقات الموبايل.',
  },
  hero: {
    eyebrow: 'تواصل معنا',
    title: 'خلّينا نحچي',
    subtitle:
      'خبّرنا شنو تريد تبني. راح تحچي مباشرة وية الناس اللي راح يصممون ويبرمجون شغلك: تطبيقات ويب، أدوات ذكاء اصطناعي، ومنتجات موبايل، من أربيل.',
    scroll: 'اسحب لتشوف أكثر',
    connect: 'خلّينا نتواصل',
  },
  info: {
    eyebrow: 'تواصل معنا',
    title: 'احجي ويانا',
    emailLabel: 'البريد الإلكتروني',
    phoneLabel: 'الهاتف',
    addressLabel: 'العنوان',
    addressLine1: 'B80، الطابق 20، أبراج MRF 2',
    addressLine2: 'شارع القرية الإنكليزية، أربيل',
  },
  form: {
    nameLabel: 'الاسم',
    namePlaceholder: 'اسمك الكامل',
    emailLabel: 'البريد الإلكتروني',
    emailPlaceholder: 'your@email.com',
    messageLabel: 'الرسالة',
    messagePlaceholder: 'خبّرنا عن مشروعك...',
    send: 'إرسال الرسالة',
    sending: 'جاري الإرسال...',
    success: 'شكراً! وصلتنا رسالتك، راح نتواصل وياك قريب.',
    error: 'صار خطأ. حاول مرة ثانية.',
    validation: {
      nameMin: 'الاسم لازم يكون حرفين على الأقل',
      emailInvalid: 'الرجاء إدخال بريد إلكتروني صحيح',
      messageMin: 'الرسالة لازم تكون 10 أحرف على الأقل',
    },
  },
  map: {
    iframeTitle: 'موقع Datacode',
    watermark: 'أربيل',
    officeLabel: 'مكتب Datacode',
    getDirections: 'الاتجاهات',
  },
  cta: {
    eyebrow: 'جاهز تشوف أعمالنا؟',
    title: 'أعمالنا',
  },
};

const ckb: typeof en = {
  meta: {
    title: 'پەیوەندیمان پێوە بکە',
    description:
      'پەیوەندی بە Datacode بکە بۆ تێکەڵکردنی زیرەکی دەستکرد، چارەسەری مۆدێلە زمانییەکان، گەشەپێدانی وێبسایت و ئەپی مۆبایل. ئۆفیسمان لە هەولێری هەرێمی کوردستانە.',
    ogTitle: 'پەیوەندیمان پێوە بکە | Datacode',
    ogDescription:
      'پەیوەندی بە Datacode بکە بۆ تێکەڵکردنی زیرەکی دەستکرد، چارەسەری مۆدێلە زمانییەکان، گەشەپێدانی وێبسایت و ئەپی مۆبایل.',
  },
  hero: {
    eyebrow: 'پەیوەندیمان پێوە بکە',
    title: 'با قسە بکەین',
    subtitle:
      'پێمان بڵێ چیت دەوێت دروستی بکەیت. قسە دەکەیت لەگەڵ ئەو کەسانەی کە خۆیان دیزاین و کۆدی دەنووسن: ئەپی وێب، ئامرازی زیرەکی دەستکرد و بەرهەمی مۆبایل، لە هەولێرەوە.',
    scroll: 'بۆ خوارەوە بڕۆ',
    connect: 'با پەیوەندی بکەین',
  },
  info: {
    eyebrow: 'پەیوەندیمان پێوە بکە',
    title: 'قسەمان لەگەڵ بکە',
    emailLabel: 'ئیمەیل',
    phoneLabel: 'تەلەفۆن',
    addressLabel: 'ناونیشان',
    addressLine1: 'B80، نهۆمی 20، بورجەکانی MRF 2',
    addressLine2: 'شەقامی گوندی ئینگلیزی، هەولێر',
  },
  form: {
    nameLabel: 'ناو',
    namePlaceholder: 'ناوی تەواوت',
    emailLabel: 'ئیمەیل',
    emailPlaceholder: 'your@email.com',
    messageLabel: 'پەیام',
    messagePlaceholder: 'باسی پرۆژەکەت بۆمان بکە...',
    send: 'ناردنی پەیام',
    sending: 'دەنێردرێت...',
    success: 'سوپاس! پەیامەکەت گەیشت، بەم زووانە پەیوەندیت پێوە دەکەین.',
    error: 'هەڵەیەک ڕوویدا. تکایە دووبارە هەوڵ بدەرەوە.',
    validation: {
      nameMin: 'ناو دەبێت لانیکەم 2 پیت بێت',
      emailInvalid: 'تکایە ئیمەیلێکی دروست بنووسە',
      messageMin: 'پەیام دەبێت لانیکەم 10 پیت بێت',
    },
  },
  map: {
    iframeTitle: 'شوێنی Datacode',
    watermark: 'هەولێر',
    officeLabel: 'ئۆفیسی Datacode',
    getDirections: 'ڕێنمایی ڕێگا',
  },
  cta: {
    eyebrow: 'ئامادەیت کارەکانمان ببینیت؟',
    title: 'کارەکانمان',
  },
};

export const contactCopy = defineCopy(en, ar, ckb);
